import { chakra, defineRecipe } from '@plurall/elo-v3';

// TODO: use the proper Elo tokens
const LocalNavigationRecipe = defineRecipe({
  className: 'local-navigation',
  base: {
    '--sidebar-bg': '#fff',
    '--sidebar-border-color': '#e5e7eb',
    '--sidebar-text-color': '#25252a',
    '--sidebar-hover-bg': 'rgba(29, 162, 149, 0.16)',
    '--sidebar-pressed-bg': 'rgba(29, 162, 149, 0.24)',
    '--sidebar-focus-visible-bg': 'var(--sidebar-hover-bg)',
    '--sidebar-selected-bg': 'var(--sidebar-hover-bg)',
    '--sidebar-active-color': '#075f57',
    '--sidebar-focus-ring-color': '#0c8e83',
    '--sidebar-border-active-color': '#0c8e83',
    '--sidebar-divider-color': '#d9d9e3',
    '--sidebar-icon-color': '#075f57',
    '--sidebar-subitem-color': '#4b5563',
    '--sidebar-indicator-color': '#5e5e69', // <- in hover - #075F5'
    '--sidebar-collapsed-hover': 'var(--sidebar-hover-bg)',
    '--sidebar-child-indent': 'calc(0.6rem + 1.4rem + var(--local-nav-title-gap))',
    '--sidebar-scrollbar-color': 'rgb(from var(--base-scrollbar-background) r g b / 0)',

    display: 'block',
    backgroundColor: 'var(--sidebar-bg)',
    inlineSize: '100%',
    borderRight: '1px solid var(--base-border-primary)',
    overflowX: 'clip',
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: 'var(--sidebar-scrollbar-color) transparent',

    transitionProperty: '--sidebar-scrollbar-color',
    transitionDuration: 'var(--sidebar-transition-duration)',
    transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.18, 1)',

    '&:hover, &:focus-within': {
      '--sidebar-scrollbar-color': 'var(--base-scrollbar-background)',
    },

    '&::-webkit-scrollbar': {
      inlineSize: 'space.6',
    },

    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'var(--sidebar-scrollbar-color)',
      borderRadius: '999px',
    },

    '@media print': {
      display: 'none',
    },
  },
});

const LocalNavigationContentRecipe = defineRecipe({
  className: 'local-navigation__content',
  base: {
    display: 'grid',
    alignContent: 'start',
    paddingBlock: 'padding.4xlarge',
    paddingInline: 'padding.xsmall',
    inlineSize: '100%',
    minBlockSize: '100%',
  },
});

export const LocalNavigationFactory = chakra('aside', LocalNavigationRecipe);
export const LocalNavigationContentFactory = chakra('div', LocalNavigationContentRecipe);
